module.exports = __webpack_public_path__ + "static/media/3_10.47c6f633.png";